import { render, staticRenderFns } from "./ed-list-inactive-classes.component.vue?vue&type=template&id=15c3c558&scoped=true&"
import script from "./ed-list-inactive-classes.component.ts?vue&type=script&lang=ts&"
export * from "./ed-list-inactive-classes.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-list-inactive-classes.component.scss?vue&type=style&index=0&id=15c3c558&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c3c558",
  null
  
)

export default component.exports